export { Avatar } from "./Avatar";
export { TeamAvatar } from "./TeamAvatar";
export { UserAvatar, NewUserAvatar } from "./UserAvatar";
export { AvatarOffDutyIndicator } from "./OffDutyIndicator";

export const MEDIUM_ICON_SIZE = 30;
